import { isFrameLikeElement } from "@excalidraw/excalidraw/element/typeChecks";
import { getFrameLikeTitle } from "@excalidraw/excalidraw/frame";

import { Modal } from "../components/Modal";

import { CommentThread } from "./CommentThread";

import type { FrameComment } from "./frameMeta";
import type { ExcalidrawElement } from "@excalidraw/excalidraw/element/types";

export type CommentModalProps = {
  frame: ExcalidrawElement;
  comments: readonly FrameComment[];
  canWrite: boolean;
  canManage(comment: FrameComment): boolean;
  onAdd(text: string): void;
  onEdit(commentId: string, text: string): void;
  onRemove(commentId: string): void;
  onClose(): void;
};

/**
 * A frame's comment thread, in a modal instead of the pane it used to be —
 * that pane hung under the frame at the frame's own width, so its write box
 * ended up sitting across whatever else shared that row (the bug this
 * modal fixes). `Modal`'s own primary/secondary row doesn't fit a chat
 * thread (a message submits itself, not the whole modal), so it's turned
 * off here with `hideActions`; `primaryLabel`/`onPrimary` below are unused
 * placeholders `Modal` still requires the props for.
 */
export const CommentModal = ({
  frame,
  comments,
  canWrite,
  canManage,
  onAdd,
  onEdit,
  onRemove,
  onClose,
}: CommentModalProps) => (
  <Modal
    title={
      isFrameLikeElement(frame) ? `${getFrameLikeTitle(frame)} 댓글` : "댓글"
    }
    className="canvaschool-modal--chat"
    hideActions
    primaryLabel=""
    onPrimary={() => {}}
    onCancel={onClose}
  >
    <CommentThread
      comments={comments}
      canWrite={canWrite}
      canManage={canManage}
      onAdd={onAdd}
      onEdit={onEdit}
      onRemove={onRemove}
    />
  </Modal>
);
